module.exports = __webpack_public_path__ + "static/media/376897.50de01ba.png";